




















































































































































































































import {Component, Ref, Vue} from "vue-property-decorator";
import {PartnerUserItem, PartnerUserItemImpl} from "@/store/user_management/partner_users/types";
import {Action, Getter} from "vuex-class";
import {SelectWings} from "wings-ui-components";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {TransportItem} from "@/store/transport/types";
import {PageBlocks} from "@/store/user_management/partner_user_roles/types";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";
import {SystemUserItem} from "@/store/user_management/system_users/types";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {SelectWings}})
export default class PartnerUser extends Vue {

  @Action("getPartnerUserItem") actionGetItem: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("savePartnerUserItem") actionSaveItem: any;
  @Action("deletePartnerUserItem") actionDeleteItem: any;
  @Action("resetPassword") actionResetPassword: any;
  @Action("getPartnerUserPageBlocks") actionGetPages: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getPartnerUserRoles") actionGetPartnerUserRoles: any;
  @Action("actionLog") actionLog: any;

  // @Getter("partners") partnersList: any;
  @Getter("timezones") timezonesList: any;
  @Getter("transports") transportsList!: TransportItem[];
  @Getter("pageBlocks") pageBlocksList: any;
  @Getter("partnerUserRoles") partnerUserRolesList: any;

  @Ref("validator") validator: any;

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  private logObject: ActionLog = {}

  partnersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners(filter);
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  defaultItem(): PartnerUserItem {
    return new PartnerUserItemImpl()
  }

  async created() {
    this.actionGetTransports();
    await this.actionGetPages();
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Personal account",
        object_name: this.item.name,
        addititional_info: getTranslatedParams({id: this.$route.params.id})
      }
      await this.actionGetItem(this.$route.params.id).then( (data: PartnerUserItem) => {
        // если с сервера приходит null
        data.status = data.status ? 1 : 0;
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        this.actionLog(this.logObject);
      }).catch(()=>{
        this.actionLog({...this.logObject, action_status: "failed"});
      });
      this.partnersList = await this.actionGetPartners({name: this.item.partner});
    }
    else {
      this.pageBlocksList.map((page:PageBlocks)=> {
        page.allowed = 1
        const pageBlock = Object.assign({}, page);
        this.item.partner_user_page_blocks?.push(pageBlock);
      });
    }
  }


  back(): void {
    this.$router.push('/user_management/partner_users/');
  }

  onSaveItem(): Promise<void> {
    return new Promise( async (resolve, reject) => {
      let valid: boolean = await this.validator.validate();
      if (valid) {
        try {
          const data = Object.assign({}, this.item);
          if (data.role_id) data.partner_user_page_blocks = undefined
          await this.actionSaveItem(data);
          await this.logChangeParams("success");
          await this.logChangePassword("success");
          await this.logChangeRole("success");
          this.itemSaved = this.item;
          resolve();
          this.back();
        } catch (err) {
          await this.logChangeParams("failed");
          await this.logChangePassword("failed");
          await this.logChangeRole("failed");
          reject();
          notifyError(err);
        }
      } else {
        setTimeout(() => {
          notifyError(null, this.validator.errors);
        }, 100);
      }
    });
  }

  async onDeleteItem() {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Personal account",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.$route.params.id})
        }
        await this.actionDeleteItem(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  async logChangeParams (action_status: string) {
    const fieldsToCompare: Array<keyof PartnerUserItem> = ['name', 'partner', 'email', 'status', 'timezone_id', 'is_check_pass'];
    const isEqualAll = fieldsToCompare.every(field => isEqual(this.item[field], this.itemSaved[field]));
    if (isEqualAll) return;
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: this.$route.params.id ? "Editing" : "Creation",
      action_status: action_status,
      object_type: "Personal account",
      object_name: this.item.name,
      addititional_info: getTranslatedParams({id: this.$route.params.id})
    }
    await this.actionLog(this.logObject);
  }

  async logChangePassword (action_status: string){
    if (!this.$route.params.id) return;
    if (!this.item.password) return;
    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Password change",
      action_status: action_status,
      object_type: "Personal account",
      addititional_info: getTranslatedParams(this.item)
    }
    await this.actionLog(this.logObject);
  }

  async logChangeRole (action_status: string) {
    if (!this.$route.params.id) return;
    const fieldsToCompare: Array<keyof PartnerUserItem> = ['partner_user_page_blocks', 'show_messages_text', 'role_id'];
    const isEqualAll = fieldsToCompare.every(field => isEqual(this.item[field], this.itemSaved[field]));
    if (isEqualAll) return;

    let roleUse = this.isUseRole ? 'Да/Yes' : 'Нет/No';
    let additionalInfo = getTranslatedParams({role_use: roleUse});

    if (!this.isUseRole) {
      const showMessagesText = this.item.show_messages_text === 1 ? 'Да/Yes' : 'Нет/No';

      const sections = this.pages?.reduce((acc: any, item) => {
        const key = this.pageBlocksList.find((e: any) => e.id === item.id);
        const value = item.allowed ? 'Доступен/Available' : 'Недоступен/Not available';
        acc[`${key.eng_name}/${key.rus_name}`] = value;
        return acc;
      }, {});
      additionalInfo = {'Разделы/Sections': sections, ...additionalInfo, ...getTranslatedParams({show_messages_text: showMessagesText})};
    } else {
      additionalInfo = {...getTranslatedParams({role: this.getRoleNameByID(this.item.role_id)}), ...additionalInfo};
    }

    this.logObject = {
      action_page: this.$route.meta.msgKey,
      action: "Access rights modification",
      action_status: action_status,
      object_type: "Personal account",
      object_name: this.item.name,
      addititional_info: additionalInfo
    }
    await this.actionLog(this.logObject);
  }

  getRoleNameByID(id?: number) {
    return this.partnerUserRolesList.find((item: any) => item.id === id)?.name;
  }

  async onResetPassword() {
    try {
      await this.actionResetPassword({email: this.item.email});
      this.back();
    } catch (error) {
      notifyError(error);
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

  get status(): any {
    return this.item.status;
  }

  set status(value: any) {
    this.item.status = (value ? 1 : 0);
  }

  get show_messages_text(): any {
    return this.item.show_messages_text;
  }

  set show_messages_text(value: any) {
    this.item.show_messages_text = (value ? 1 : 0);
  }

  get is_check_pass(): any {
    return this.item.is_check_pass;
  }

  set is_check_pass(value: any) {
    this.item.is_check_pass = (value ? 1 : 0);
  }

  get isUseRole():boolean {
    return !!this.item.role_id
  }

  set isUseRole(value:boolean) {
    if (value) {
      this.item.role_id = 1;
    } else {
      this.item.role_id = undefined;
      if (!this.item.partner_user_page_blocks || this.item.partner_user_page_blocks.length === 0) {
        this.item.partner_user_page_blocks = this.pageBlocksList;
      }
    }
  }

  get pages() {
    return (
        this.item.partner_user_page_blocks?.filter(
            (e: any) => e.id !== 1 && e.id !== 2
        ) ?? []
    );
  }

  getNamePageByLang(page: PageBlocks): string | undefined {
    if (this.$i18n.locale === "ru") {
      return page?.rus_name;
    } else {
      return page?.eng_name;
    }
  }
};
